// ----------------------------------------------------------------------
export var ControlLabel = function ControlLabel(_ref) {
  var theme = _ref.theme;
  return {
    // FormControlLabel
    MuiFormControlLabel: {
      styleOverrides: {
        label: Object.assign({}, theme.typography.body2)
      }
    },
    // FormHelperText
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: 8
        }
      }
    },
    // FormLabel
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.disabled
        }
      }
    }
  };
};